import React from "react";

const Sixtydaystable = ({ data = [] }) => {
    return (
        <div className="p-4 overflow-x-auto">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left border-r border-blue-400">Dealer Name</th>
                        <th className="px-4 py-2 text-left border-r border-blue-400">PPL</th>
                        <th className="px-4 py-2 text-left border-r border-blue-400">PL</th>
                        <th className="px-4 py-2 text-left border-r border-blue-400">Count</th>
                        <th className="px-4 py-2 text-left">Date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((item, i) => (
                            <tr
                                key={i}
                                className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}
                            >
                                <td className="px-4 py-2 border-t border-blue-200">{item.dealer}</td>
                                <td className="px-4 py-2 border-t border-blue-200">{item.ppl}</td>
                                <td className="px-4 py-2 border-t border-blue-200">{item.pl}</td>
                                <td className="px-4 py-2 border-t border-blue-200">{item.count}</td>
                                <td className="px-4 py-2 border-t border-blue-200">{item.date}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td
                                colSpan={5}
                                className="text-center py-4 text-gray-500 border-t border-blue-200"
                            >
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Sixtydaystable;
